var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllergen1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeWidth: 1.5,
    d: "m6.895 9.105 2.438-2.438 2.438 2.438c.771.77 1.156 1.156 1.36 1.646.202.49.202 1.035.202 2.125v16.457h-2.666c-2.514 0-3.772 0-4.553-.78-.78-.782-.78-2.039-.78-4.553V12.876c0-1.09 0-1.635.202-2.125.203-.49.589-.876 1.36-1.646Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M9.333 6.672v-.533c0-1.632 0-2.448.508-2.955.508-.507 1.325-.507 2.959-.507h7.405c.942 0 2.164-.15 2.793.708.669.912.098 2.165.387 3.172.088.307.306.543.506.783l2.776 3.327"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.333 10.667h13.334V24c0 2.514 0 3.771-.781 4.552-.781.781-2.038.781-4.553.781h-8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "svgStroke",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.333 17.333c.635.667 2.325.635 3.316.372a1.785 1.785 0 0 1 1.905.647l.916 1.202c.527.692 1.326 1.02 2.113.869l1.16-.223c.637-.123 1.272.187 1.706.74 1.354 1.727 2.218 1.727 2.218 1.727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllergen1);
export default __webpack_public_path__ + "static/media/allergen1.6a2b03bb21701d10641d8919fc613611.svg";
export { ForwardRef as ReactComponent };